import { useEffect, useState } from "react";
import { quotationAPI } from "../../api/quotationAPI";

export default function QuotationTypeSearch(
    { pCode, setQuotationNo, setDescription, setIsAllQuotationNoChecked,
        onLoadQuotationDetails
    }) {
    const [allQuotationNo, setAllQuotationNo] = useState([]);

    const getAllQuotation = (searchKey = '') => {
        quotationAPI.getAllQuotation(pCode, searchKey).then((data) => {
            setAllQuotationNo(data);
        })
    }

    const handleRowSelect = (code, name) => {
        setQuotationNo(code);
        setDescription(name);
        setIsAllQuotationNoChecked(false);

        getQuotationDetails(pCode, code);
    }

    useEffect(() => {
        if (pCode) {
            getAllQuotation()
        }
    }, [pCode]);

    const getQuotationDetails = (pCode, quotationNo) => {
        quotationAPI.getQuotationDetails(pCode, quotationNo).then((data) => {
            if (onLoadQuotationDetails) onLoadQuotationDetails(data);
        })
    }

    return (
        <div className="modal fade" id="quotationTypeSearch" tabIndex="-1" aria-hidden="true">
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Quotation No</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
                    </div>
                    <div className="modal-body">
                        <input type="text" className="form-control" placeholder="Search by code or name"
                            onChange={(e) => getAllQuotation(e.target.value)}
                        />
                        <table className="table mt-1">
                            <thead className="thead--color">
                                <tr>
                                    <th scope="col">Code</th>
                                    <th scope="col">Name</th>
                                    <th className="text-center">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {allQuotationNo && allQuotationNo.map(data => (
                                    <tr key={data.quotationNo}>
                                        <td>{data.quotationNo}</td>
                                        <td>{data.repName}</td>
                                        <td className="text-center"><button type="button" className="btn btn-sm btn-dark"
                                            onClick={() => handleRowSelect(data.quotationNo, data.repName)} data-bs-dismiss="modal">
                                            Select</button></td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    )
}